var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status===1 && _vm.supportGroupBuying && _vm.showDynamics)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"dynamics-wrap"},[_c('img',{staticClass:"dynamics-img",attrs:{"src":_vm.currentDynamics.img}}),_c('span',{staticClass:"dynamics-text"},[_vm._v(_vm._s(_vm.currentDynamics.text))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-655207b4","hasScoped":false,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./libs/components/detail/groupBuying/groupDynamics.vue
// module id = 701
// module chunks = 0